import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { Acceleration } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * The gravity sensor provides on each reading the gravity applied to the device along all three axes.
 * @category data
 */
let GravitySensor = class GravitySensor extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new Acceleration(), frequency, displayName);
  }
};
GravitySensor = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, Acceleration, Number, String])], GravitySensor);
export { GravitySensor };